import { useSelector } from 'react-redux';
import { isFeatureEnabled } from '../store/adminShell/selectors';
import { FeatureFlags } from './featuresFlagsTypes';

export const RTSPRO_BRAND_NAME = 'RTS Pro';
export const RTS_BRAND_NAME = 'RTS';

export const getRtsBrandName = (isRtsRebrand: boolean) => (isRtsRebrand ? RTS_BRAND_NAME : RTSPRO_BRAND_NAME);

export const useIsRtsRebrand = () => useSelector(isFeatureEnabled(FeatureFlags.RTS_REBRAND));
